
const BrowserInstructions = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-bobo-green mb-3">Browser Settings</h3>
      <p className="text-gray-700 leading-relaxed mb-4">
        Most web browsers allow you to control cookies through their settings. You can:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
        <li>Block all cookies</li>
        <li>Allow only essential cookies</li>
        <li>Delete existing cookies</li>
        <li>Set cookies to be deleted when you close your browser</li>
      </ul>

      <h3 className="text-lg font-semibold text-bobo-green mb-3 mt-6">Browser-Specific Instructions</h3>
      <div className="bg-gray-50 p-4 rounded-lg">
        <ul className="text-gray-700 text-sm space-y-1">
          <li><strong>Chrome:</strong> Settings {'>'}  Privacy and Security {'>'} Cookies and other site data</li>
          <li><strong>Firefox:</strong> Preferences {'>'} Privacy & Security {'>'} Cookies and Site Data</li>
          <li><strong>Safari:</strong> Preferences {'>'} Privacy {'>'} Cookies and website data</li>
          <li><strong>Edge:</strong> Settings {'>'} Privacy, search, and services {'>'} Cookies and site permissions</li>
        </ul>
      </div>

      <p className="text-gray-700 leading-relaxed mt-4">
        <strong>Note:</strong> Blocking essential cookies may affect the functionality of our website and prevent you from using certain features.
      </p>
    </div>
  );
};

export default BrowserInstructions;
